import { render, staticRenderFns } from "./ResetPosition.vue?vue&type=template&id=7d6de83b"
import script from "./ResetPosition.vue?vue&type=script&lang=js"
export * from "./ResetPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports